import { createStyles, makeStyles } from "@mui/styles";

export const useInputLabelStyles = makeStyles(() =>
  createStyles({
    label: {
      marginBottom: 4,
      fontFamily: "Segoe UI !important",
      fontWeight: "600 !important",
      fontSize: "12px !important",
      lineHeight: "16px !important",
      letterSpacing: 0,
      color: "#1E1E1E",
      display: "flex",
      alignItems: "flex-end",
      "&.Mui-disabled": {
        color: " #0000004D"
      },
      "&.Mui-error": {
        color: "#DC0000"
      },
      "& .MuiInputLabel-asterisk": {
        order: -1,
        marginRight: 4,
        color: "#005F87",
        fontSize: "16px",
        fontWeight: 600,
        fontFamily: "Segoe UI !important",
        lineHeight: "16px",
        "&.Mui-error": {
          color: "#DC0000"
        }
      }
    },
    labelFlex: {
      display: "flex",
      alignItems: "center"
    },
    errorText: {
      color: "#DC0000",
      fontSize: 12,
      marginLeft: 4,
      fontFamily: "Segoe UI",
      fontWeight: 400,
      lineHeight: "16px"
    },
    hintText: {
      fontFamily: "Segoe UI",
      fontWeight: 400,
      fontStyle: "italic",
      fontSize: 12,
      lineHeight: "16px",
      letterSpacing: 0,
      color: "#6E6E6E",
      marginTop: 2
    }
  })
);
